import React from 'react'
import { geometriaDoMedidor, reais, debito } from '../../../libs/disparos'

// Medidor do saldo: agora, a fatia que este envio leva e o que sobra, numa
// régua só com o zero e o limite marcados. Usado no recibo do disparo, no
// custo do agendamento e no "Reenviar com erro". Precisa estar dentro de um
// elemento com as variáveis de tokensDoDisparo e o disparo.css carregado.
export default function MedidorDeSaldo({ atual, comprometido = 0, total, tolerancia = 0, rotuloDoEnvio = 'Este disparo' }) {
  const g = geometriaDoMedidor({ atual, comprometido, total, tolerancia })
  if (g.depois == null) return null

  return (
    <div className="dp-medidor">
      <div
        className="dp-trilho"
        role="img"
        aria-label={`Saldo agora ${reais(atual)}; ${rotuloDoEnvio.toLowerCase()} ${debito(total)}; depois ${reais(g.depois)}`}
      >
        {g.faixas.map((f) => (
          <span key={f.tipo} className={`dp-faixa ${f.tipo}`} style={{ left: `${f.esquerda}%`, width: `${f.largura}%` }} />
        ))}
        {g.marcos.map((m) => (
          <span key={m.tipo} className={`dp-marco ${m.tipo}`} style={{ left: `${m.em}%` }} />
        ))}
      </div>
      <div className="dp-legenda">
        <div>Agora<b className={atual < 0 ? 'neg' : ''}>{reais(atual)}</b></div>
        {g.estoura ? (
          <div>Limite<b>{reais(tolerancia)}</b></div>
        ) : (
          <div>{rotuloDoEnvio}<b>{debito(total)}</b></div>
        )}
        <div>Depois<b className={g.estoura ? 'neg' : ''}>{reais(g.depois)}</b></div>
      </div>
      {comprometido > 0 && (
        <span className="dp-reservado-nota">
          Já desconta {reais(comprometido)} reservados para envios em andamento.
        </span>
      )}
    </div>
  )
}
